export const TechnologyState: ITechnologyState = {
    pageTitle: 'Technologies',
    pageSubtitle: 'Agilie builds mobile and web B2B and B2C solutions. We research, design, and code for your product’s success.',
    sectionLinks: [
        {
            title: 'Big Data Analytics',
            relatedToSection: '#big-data'
        },
        {
            title: 'Blockchain consulting',
            relatedToSection: '#blockchain'
        },
        {
            title: 'Web development',
            relatedToSection: '#web'
        },
        {
            title: 'Mobile development',
            relatedToSection: '#mobile'
        },
        {
            title: 'UI/UX design',
            relatedToSection: '#design'
        },
        {
            title: 'MVP development',
            relatedToSection: '#mvp'
        },
        {
            title: 'QA testing',
            relatedToSection: '#qa'
        },
        {
            title: 'Internet of things',
            relatedToSection: '#iot'
        },
        {
            title: 'Maintenance / Support',
            relatedToSection: '#maintenance'
        },
    ],
    sections: [
        {
            title: 'UI/UX design',
            id: 'design',
            subtitle: [
                'We provide our clients with holistic design services fueled with creativity, wide knowledge in many domain industries, and years of expertise. By researching users’ needs and behavior, we can help you see your product through customers’ eyes, create intuitive UI and UX that your users will love, and save your time and money on the development process.',
                'We apply the best UI/UX practices to all the stages of design development — from creating concepts to design validation. Whether you need a design from scratch or update of your existing one, we will ensure that all your business objectives and requirements are met.'
            ],
            link: '/expertise/technology/ui-ux-design',
            technologies: ['Figma', 'Sketch', 'Invision', 'Adobe'],
            image: '/technologies-images/design.png',
        },
        {
            title: 'Cloud computing',
            id: 'cloud-computing',
            subtitle: [
                'With our cloud computing services, you can create reliable IT infrastructure through the cloud. Get access to all the business data no matter where you are, scale with ease, and increase your productivity while also saving money.',
                'If you are looking for an efficient and secure off-site data backup, we have got you covered. With Agilie, your data, work, and apps will be available from any device with an internet connection.'
            ],
            technologies: ['Firebase', 'Amazon Web Services', 'DigitalOcean'],
            image: '/technologies-images/cloud-computing.png',
        },
        {
            title: 'Mobile Development',
            id: 'mobile',
            subtitle: [
                'Agilie will unlock the full potential of mobile development for your company. With all the needed expertise, we provide native and cross-platform mobile app development services to delight your users and increase your profit.',
                'We offer the right balance between quality, price, and customers’ requirements to build the perfect fit for your particular case. Our seasoned team of experts will make any of your ideas alive, no matter their complexity, according to the negotiated requirements and within a specified timeframe.'
            ],
            link: '/expertise/technology/mobile-development',
            technologies: ['iOS', 'Android', 'Cross-platform'],
            image: '/technologies-images/mobile.png',
        },
        {
            title: 'MVP development',
            id: 'mvp',
            image: '/technologies-images/mvp.png',
            link: '/expertise/technology/mvp-development',
            subtitle: [
                'We can help you easily validate your business ideas with no heavy upfront investment. Bring your product to the market fast and efficiently, and evolve it by adding the necessary features on the go after receiving feedback from early adopters.',
                'With our MVP development services, you can successfully pitch working ideas to investors without having a full-fledged product at hand and a long discovery stage. Test waters on the target market, find out your weak spots, and make only informed business decisions.'
            ],
            technologies: []
        },
        {
            title: 'QA testing',
            id: 'qa',
            subtitle: [
                'Our services include a full suite of Quality Assurance testing services. We thoroughly monitor each stage of the development process and give you detailed product quality data to ensure that the final product is trouble-free.',
                'At Agilie, we employ the latest QA practices, tech stack, and standards so that you get high-quality software within a specified deadline. We ensure that no bug will come up once the product is launched, which will increase your customers’ trust and loyalty for sure.'
            ],
            link: '/expertise/technology/qa-testing',
            technologies: ['TestFlight', 'Cypress', 'Jest', 'Firebase'],
            image: '/technologies-images/qa.png',
        },
        {
            title: 'Web development',
            id: 'web',
            subtitle: [
                'We offer reliable custom web development services to ensure the presence of your company online. Our engaging web products are trusted by users and are pleasing to your eyes. Agilie always provides clear code, high-quality services, and fast performance.',
                'We can help you find a solution that matches your business needs and preserve your vision. We work across numerous industries, such as financial services, real estate, healthcare, logistics, media, or e-commerce.'
            ],
            link: '/expertise/technology/web-development',
            technologies: ['JavaScript', 'Ruby on Rails', 'Angular', 'ReactJS'],
            image: '/technologies-images/web.png',
        },
        {
            title: 'Blockchain consulting',
            id: 'blockchain',
            subtitle: [
                'At Agilie, you can get solid expertise on digital technologies needed to build successful blockchain- and cryptocurrency-related solutions to excel in the blockchain world. No matter if you are just diving into blockchain space or want to launch a product already, we will help you out. There are several successful businesses we assisted in creation of blockchain-based solutions.',
                'Our main goal is to aid companies to apply the latest technologies to drive their digital transformations and achieve lasting gains. That is why we start with defining your aspirations and then find practical applications of blockchain technology.'
            ],
            technologies: [],
            image: '/technologies-images/blockchain.png',
        },
        {
            title: 'Big Data Analytics',
            id: 'big-data',
            subtitle: [
                'We know how difficult it is to deal with large silos of real-time data coming in daily from multiple sources. With our intelligent big data tools and years of hands-on experience, we help companies to consolidate all types of data into one unified environment to easily extract valuable insights.',
                'Forget about wasting your time on untapped data assets. We can help you easily analyze large quantities of data by creating perfect data infrastructure using smart tools for data storage, processing, and analyzing.'
            ],
            technologies: ['Kafka', 'Elasticsearch'],
            image: '/technologies-images/big-data.png',
        },
        {
            title: 'Internet of things',
            id: 'iot',
            subtitle: [
                'We help businesses harness the power of the Internet of Things (IoT) by building data-rich solutions that would help you increase your productivity, better manage your operations, and easily transform into a smart enterprise.',
                'Be it software enhancement, full-cycle development, or just IoT integration, we are helping businesses unlock their full potential and understand the opportunities the Internet of Things can bring to your very business.'
            ],
            technologies: [],
            image: '/technologies-images/iot.png',
        },
        {
            title: 'Maintenance / Support',
            id: 'maintenance',
            subtitle: [
                'Our work doesn’t end right when the development process is over. We deliver post-production full-range maintenance and support services to ensure that your products are reliable, available, and meet the constantly evolving needs of your business.',
                'You can rest assured that your product ecosystem runs smoothly and is stable while we take care of diagnosing potential problems, troubleshooting, and ongoing technical support.'
            ],
            technologies: [],
            image: '/technologies-images/maintenance.png',
        },

    ]
}

export interface ITechnologyState {
    pageTitle: string;
    pageSubtitle: string;
    sections: Array<ISectionsTech>;
    sectionLinks: ISectionLink[];
}

export interface ISectionsTech {
    id: string;
    title: string;
    subtitle: Array<string>;
    link?: string;
    technologies: Array<string>;
    image: string;
}

export interface ISectionLink {
    title: string;
    relatedToSection: string;
}
